import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
} from '@material-ui/core';
import React, { FC, useState } from 'react';
import { createUseStyles } from 'src/theming';
import AgencySelect from './AgencySelect';
import LegacyEmployeeSelect from 'src/components/ApiField/LegacyEmployeeSelect';

export type CustomersFilter = 'employees' | 'agencies' | 'displayProspect' | 'displayLost' | 'displayWin';

interface Props {
  filters: Partial<Record<CustomersFilter, any>>;
  open: boolean;
  onClose: () => void;
  onChange: (filters: Partial<Record<CustomersFilter, any>>) => void;
}

const useStyles = createUseStyles({
  root: {
    width: '100%',
  },
  select: {
    width: '100%',
  },
});

const FiltersDialog: FC<Props> = ({ onChange, onClose, open, ...props }) => {
  const classes = useStyles();
  const [filters, setFilters] = useState<Partial<Record<CustomersFilter, any>>>(props.filters);

  const handleFilterSave = () => {
    onChange(filters);
    onClose();
  };

  const handleFilterChange = (key: CustomersFilter, value: any) => {
    setFilters((filters) => ({ ...filters, [key]: value }));
  };

  return (
    <Dialog className={classes.root} onClose={onClose} open={open} maxWidth='lg' fullWidth>
      <DialogTitle>Filtrer les clients</DialogTitle>

      <DialogContent>
        <Grid container spacing={2}>
          <Grid item md={6}>
            <AgencySelect
              className={classes.select}
              value={filters.agencies || []}
              onChange={(value) => handleFilterChange('agencies', value)}
            />
          </Grid>

          <Grid item md={6}>
            <LegacyEmployeeSelect
              className={classes.select}
              value={filters.employees || []}
              multiple
              onChange={(value) => handleFilterChange('employees', value)}
            />
          </Grid>

          <Grid item md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.displayProspect}
                  onChange={(event) => handleFilterChange('displayProspect', event.target.checked)}
                />
              }
              label='Afficher les prospects'
            />
          </Grid>

          <Grid item md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.displayLost}
                  onChange={(event) => handleFilterChange('displayLost', event.target.checked)}
                />
              }
              label='Afficher les clients perdus'
            />
          </Grid>

          <Grid item md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.displayWin}
                  onChange={(event) => handleFilterChange('displayWin', event.target.checked)}
                />
              }
              label='Afficher les clients gagnés'
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' color='primary' onClick={handleFilterSave}>
          Filtrer
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FiltersDialog;
